export default __webpack_public_path__ + "static/media/madhav.cde55586.jpg";